<span class="badge badge-pill badge-tag" [title]="tooltipText()">
	<i *ngIf="showX"
		class="fa fa-fw fa-times"
		style="cursor: pointer;"
		(click)="clickX.emit($event)"></i>
	<keyword-highlight
		[keyword]="keyword"
		[text]="valueText()"></keyword-highlight>
</span>
